/** Upper bound of rows per server-owned import run (BE PRODUCT_IMPORT_MAX_ROWS). */
export const PRODUCT_IMPORT_MAX_ROWS = 20_000;

const PAGE_FETCH_CONCURRENCY = 4;

/**
 * Fetch pages 2..N of a paginated list with at most PAGE_FETCH_CONCURRENCY
 * requests in flight, returning them in page order.
 */
export async function fetchRemainingPages<T>(
  total: number,
  pageSize: number,
  fetchPage: (page: number) => Promise<T>,
): Promise<T[]> {
  const pages = Array.from({ length: Math.max(0, Math.ceil(total / pageSize) - 1) }, (_, index) => index + 2);
  const results: T[] = new Array(pages.length);
  let next = 0;
  const worker = async () => {
    while (next < pages.length) {
      const slot = next;
      next += 1;
      results[slot] = await fetchPage(pages[slot]);
    }
  };
  await Promise.all(Array.from({ length: Math.min(PAGE_FETCH_CONCURRENCY, pages.length) }, worker));
  return results;
}
